import { ButtonText } from "components/Atoms/Button";
import React from "react";

interface ViewOnMapProps {
  height: number;
}

export const ViewOnMap = (props: React.PropsWithChildren<ViewOnMapProps>) => {
  const [isMapVisible, setIsMapVisible] = React.useState(false);

  if (isMapVisible) {
    return <>{props.children}</>;
  }

  return <div className="google-map-view-on-map-placeholder" style={{ height: props.height, minHeight: props.height }}>
    <ButtonText onClick={() => setIsMapVisible(true)} label="View on map" />
  </div>
}